import React from "react";
import { Link } from "react-router-dom";
const Warranty = () => {
  return (
  <div>
      {/* Spinner Start */}
     
      {/* Spinner End */}
  
      {/* Topbar Start */}
   
      {/* Topbar End */}
  
      {/* Navbar Start */}

      {/* Navbar End */}
  <div class="container">
      <section class="history-section">
        <h2 class="section-title">OUR HISTORY</h2>
        <p>
            "Founded on the principles of experience, innovation, and unwavering commitment, Tileque Surfaces LLP has been a stalwart in the flooring industry for over three decades. 
            Strategically positioned within a 2-hour radius, less than 150KM from Mundra Port, our journey commenced with a visionary goal to redefine the benchmarks of quality and sustainability in flooring."
        </p>
        <p>
            At the heart of our operations lies a production capacity that exceeds 30 million square feet, a testament to our dedication to meeting the demands of our clients efficiently.
            Our sprawling 100,000 sq feet floor plan, orchestrated by a dedicated team of over 50 skilled professionals, exemplifies our commitment to innovation and excellence at Tileque Surfaces LLP.
        </p>
        <p>
            Tileque Surfaces LLP, the visionary force behind Plankton Floors, was founded by the three stalwarts of the flooring industry - Mr. Bharatbhai Patel, Mr. Keshavbhai Patel, and Mr. Lajibhai Patel.
            Their collaboration was not just about business but a shared vision to redefine quality and craftsmanship.
        </p>
    </section>

    <section class="vision-section">
        <h2 class="section-title">VISION</h2>
        <p>
            "At Tileque Surfaces LLP, we envision Plankton Floors as not just a flooring solution but a statement of quality and innovation.
            We strive to set new benchmarks by marrying cutting-edge technology with a relentless commitment to excellence."
        </p>
        <p>
            Our vision extends beyond the conventional norms of business. We aspire to be more than just a flooring solution provider; we aim to elevate the quality of life for our workers 
            and contribute to a greener, sustainable future.
        </p>
        <p class="highlight-text">
            "Every plank tells a story, and at Plankton Floors, we are the storytellers of elegance and excellence."
        </p>
    </section>

    <section class="mission-section">
        <h2 class="section-title">MISSION</h2>
        <p>
            "Our mission is to lead the flooring industry by providing unparalleled products. Through innovative technologies, automated processes, and a commitment to quality at every checkpoint,
            we aim to enrich lives, foster lasting relationships, and contribute to a sustainable future."
        </p>
        <p>
            We aren’t just producing floors; we’re crafting narratives of trust and quality. With cutting-edge technology and a human touch, our mission is to enrich lives and spaces.
            Plankton Floors is our pledge—a promise to elevate surroundings, uplift lives, and set new standards in the industry.
        </p>
        <p class="highlight-text">
            "Success in business requires training and discipline and hard work. But if you're not frightened by these things, the opportunities are just as great today as they ever were."
        </p>
    </section>
    </div>

  <a href="#" className="btn btn-lg btn-primary btn-lg-square rounded-0 back-to-top">
      <i className="bi bi-arrow-up"></i>
    </a>


      {/* Optional: Add any other content or components here */}
  
      <style>
        {`
          /* Add your custom CSS here */
          .service-item-top {
            transition: transform 0.3s ease-in-out;
          }
  
          .service-item-top:hover {
            transform: scale(1.05);
          }
          .history-section, 
.vision-section, 
.mission-section {
   
    margin: 40px auto;
    padding: 40px;
    background: #fff;
    border-radius: 10px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

/* Section Title */
.section-title {
    text-align: center;
    font-size: 26px;
    font-weight: bold;
    text-transform: uppercase;
    margin-bottom: 20px;
    color: #111;
}

/* Highlighted Quotes */
.highlight-text {
    font-style: italic;
    font-size: 18px;
    font-weight: bold;
    text-align: center;
    color: #15803d; /* Green color */
    margin-top: 20px;
    border-left: 5px solid #15803d;
    padding-left: 15px;
}

/* Responsive Design */
@media (max-width: 768px) {
    .history-section, 
    .vision-section, 
    .mission-section {
        padding: 20px;
    }

    .section-title {
        font-size: 22px;
    }

    .highlight-text {
        font-size: 16px;
    }
}
  
          /* Add any additional styling you want */
        `}
      </style>
    </div>
  );
};

export default Warranty;
